import { siteInfo } from '@/mocks/webtoons';

const faqs = [
  {
    question: '韩漫网上的漫画都是免费的吗？',
    answer: '是的，韩漫网上的所有韩国漫画资源均免费提供，无需任何付费或订阅。您只需要访问我们的网站，即可开始免费在线阅读各类韩漫作品。',
  },
  {
    question: '韩漫网更新频率如何？',
    answer: '我们与韩国各大漫画平台保持同步更新，热门漫画通常在韩国发布后24小时内上线中文版本。您可以关注喜欢的作品，不错过任何更新。',
  },
  {
    question: '韩漫网支持哪些设备阅读？',
    answer: '韩漫网采用响应式设计，完美适配电脑、平板和手机等多种设备。无论您使用什么设备，都能获得流畅舒适的漫画阅读体验。',
  },
  {
    question: '需要注册账号才能阅读吗？',
    answer: '不需要。韩漫网坚持无障碍阅读理念，您无需注册账号即可直接浏览和阅读所有漫画内容。打开网站，选择喜欢的作品，即刻开始阅读。',
  },
  {
    question: '韩漫网有哪些类型的漫画？',
    answer: '我们提供丰富的漫画类型，包括恋爱、动作、奇幻、悬疑、搞笑、剧情、恐怖和日常等多种分类。无论您喜欢什么题材，都能在这里找到心仪的作品。',
  },
];

export default function FAQSection() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-8 text-center">
          常见问题
        </h2>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group rounded-xl bg-background-100 border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer select-none">
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.question}</span>
                <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-700 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}